import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export default class idolLoudSpeakerListAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getIdolLoudSpeakerList', {
      url: '/admin/horn/index',
      name: 'list',
      label: '列表'
    }],
    // ['refreshGuessingGamePraizesDetail', {
    //   url: '/admin/guess/question/view',
    //   name: 'guessing-game-detail',
    //   label: '大明星喇叭详情'
    // }],
    ['addIdolLoudSpeaker', {
      url: '/admin/horn/add',
      name: 'add-loud-spreaker',
      label: '添加大明星喇叭'
    }],
    ['updateIdolLoudSpeaker', {
      url: '/admin/horn/edit',
      name: 'edit-loud-spreaker',
      label: '编辑大明星喇叭'
    }],
    ['deleteIdolLoudSpeaker', {
      url: '/admin/horn/del',
      name: 'delete-loud-spreaker',
      label: '删除大明星喇叭'
    }],

    ['sanYouDevice', {
      url: '/admin/aqara/sanYouDevice',
      name: 'sanYou-device-list',
      label: '授权闪优设备列表',
    }],
    
    // ['changeGuessingGameAnswer', {
    //   url: '/admin/guess/question/answer',
    //   name: 'set-loud-spreaker-quation-answer',
    //   label: '设置大明星喇叭问题答案'
    // }]
   
  ])

  // 大明星喇叭列表
  public getIdolLoudSpeakerList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getIdolLoudSpeakerList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }
  // // 大明星喇叭详情
  // public refreshGuessingGamePraizesDetail(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('refreshGuessingGamePraizesDetail').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // 修改大明星喇叭
  public updateIdolLoudSpeaker(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('updateIdolLoudSpeaker').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 添加大明星喇叭
  public addIdolLoudSpeaker(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('addIdolLoudSpeaker').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 删除大明星喇叭
  public deleteIdolLoudSpeaker(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('deleteIdolLoudSpeaker').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

    // 闪优设备列表
  public sanYouDevice(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('sanYouDevice').url

    this.BasicPost(url, {
        ...params
    }, false, false, false, successCb, failCb, showLoading)
}

  // // 设置大明星喇叭答案
  // public changeGuessingGameAnswer(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('changeGuessingGameAnswer').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }
  
}